import React, { useRef, useState, useEffect, useCallback } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import xorWith from 'lodash/xorWith';
import isEqual from 'lodash/isEqual';

import ListingWrapper from 'containers/ListingWrapper';
import SelectStone from 'components/DiamondListing/SelectStone';
import ListingTableWrapper from 'containers/ListingTableWrapper';
import DiamondListingAction from 'components/DiamondListing/DiamondListingAction';
import { FilterTopContainer, FilterTopInnerField } from 'components/List/FilterTop';
import ListFooter from 'components/List/ListFooter';
import CustomerDropdown from 'components/List/CustomerDropdown';
import Pagination from 'components/List/Pagination';
import Table, { LIMIT } from '../TableBack';
import CommonApi from 'constants/CommonApi';
import { canadaForeverMarkFilter, fetchcolumnAsync } from '../inventoryFunctions';
import { groupingArray } from 'services/groupingArray';
import UtilService from 'services/util';
import { isEmpty, queryStringToObject } from 'util/utils';
import { useCompositeState } from 'util/hooks';
import { USERS_TYPE } from 'constants/Common';
import Storage from 'services/storage';
import { getLoginPermission, MAINMODULE, MODULES } from 'constants/permission';
import { GRID_COLUMN } from 'constants/Inventory';

const currentType = 'upcomingList';

export const getState = (additionalState = {}) => ({
  client: null,
  data: [],
  page: 1,
  limit: LIMIT,
  sum: {},
  count: 0,
  loading: false,
  DefaultData: [],
  seachFilterTag: {},
  ...additionalState,
});

export const isArrayEqual = (x, y) => isEmpty(xorWith(x, y, isEqual));

const UpcomingDiamond = (props) => {
  const [state, setState] = useCompositeState(
    getState({
      client: Storage.get(`default-client`),
    }),
  );
  const [columns, setColumns] = useState([]);

  const sortRef = useRef([
    { rvDt: 'DESC' },
    { shpSq: 'ASC' },
    { sizeSeq: 'DESC' },
    { clrSq: 'ASC' },
    { colSq: 'ASC' },
    { crt: 'DESC' },
    { lbSq: 'ASC' },
  ]);
  const dispatch = useDispatch();

  const loginUser = useSelector((state) => state.auth?.authUser);

  const fetchColumn = React.useCallback(async () => {
    const fetchedColumns = await fetchcolumnAsync();
    let columns = fetchedColumns.filter((column) => !['inDt'].includes(column.id));
    let isShowBack = getLoginPermission().filter(
      (el) => el.mainModule === MAINMODULE.INVENTORY && el.module === MODULES.INVENTORY.SINGLE_STONE.MODULE.UPCOMING,
    )[0].permissions.isShowBack;
    if (!isShowBack) {
      columns = fetchedColumns.filter((column) => !['back', 'ctPr', 'amt'].includes(column.id));
    }
    setColumns(columns);
  }, []);

  const fetch = useCallback(async () => {
    setState({ loading: true, data: [], count: 0, sum: {} });
    const client = props?.client?.user?.id || state?.client?.user?.id;
    const user = !isEmpty(client) ? [client] : undefined;
    const sort = sortRef.current;
    const diamondSearchId = queryStringToObject()?.result;

    const requestConf = {
      ...CommonApi.Diamond.paginate,
      request: {
        page: state?.page,
        limit: state?.limit,
        isUpcoming: true,
        ...(!isEmpty(user) && { user }),
        ...(!isEmpty(sort) && { sort }),
        filters: [
          {
            wSts: 'U',
            ...canadaForeverMarkFilter(),
            // inDt: { '<=': moment().add(7, 'days').endOf('day').toISOString() },
            ...(diamondSearchId && { diamondSearchId }),
            ...(loginUser?.type === USERS_TYPE.SELLER && { sSts: { nin: ['P', 'D'] } }),
          },
        ],
      },
    };
    const [, res] = await UtilService.callApiAsync(requestConf);
    if (res?.code === 'OK') {
      const rows = res?.data?.[0]?.diamonds;
      const sum = res?.data?.[0]?.total?.[0];
      const count = res?.data?.[0]?.count;
      const seachFilterTag = res?.data?.[0]?.filter;

      const data = rows.map(({ inDt, ...diamond }) => ({
        ...diamond,
        // userDate: getDate(inDt),
        userDate: moment(inDt).format('DD/MM/YYYY'),
        // + moment.tz('Asia/Calcutta').zoneAbbr(),
      }));
      const grouppedData = groupingArray(data, 'userGroupHold', undefined, 'userDate');
      setState({ data: grouppedData, DefaultData: data, sum, count, seachFilterTag });
    }
    setState({ loading: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setState, state?.page, state?.limit, loginUser?.type]);

  const handleSort = useCallback(
    (currentSort) => {
      if (JSON.stringify(currentSort) !== JSON.stringify(sortRef.current)) {
        sortRef.current = currentSort;
        fetch();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fetch],
  );

  const clearAllSelectedRows = React.useCallback(() => dispatch({ type: 'RESET_SELECTED_ROWS' }), [dispatch]);
  const onPaginationChange = React.useCallback((page, limit) => setState({ page, limit }), [setState]);
  const onClientChange = React.useCallback((client) => setState({ client }), [setState]);

  useEffect(() => {
    fetchColumn();
  }, [fetchColumn]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <ListingWrapper>
      <SelectStone sum={state.sum} currentType={currentType} />
      <FilterTopContainer>
        <FilterTopInnerField noPopup grid={GRID_COLUMN.GRID_DIAMOND_LIST_ADMIN} />
        <CustomerDropdown value={state.client} onChange={onClientChange} />
      </FilterTopContainer>
      <ListingTableWrapper subtractFrom=".customerMaintab,.customerSubTab,.diamondListingAction,.filterTopMainBlock,.botoomStickyBar">
        <Table
          data={state.data}
          columns={columns}
          loading={state.loading}
          handleSort={handleSort}
          currentType={currentType}
          initialSort={sortRef.current}
          nostatus
        />
      </ListingTableWrapper>
      {!isEmpty(state?.data) && state?.count > 0 && (
        <ListFooter contentSpaceBetween>
          <DiamondListingAction
            {...props}
            {...state}
            columns={columns}
            ActionFalse={false}
            share
            download
            printList
            compareStone
            mailList
            noContainer
            watchList
            clearAll={clearAllSelectedRows}
            fetch={fetch}
            tabPrintExcel="inUpComing"
            currentType={currentType}
            modifySearch
          />
          <Pagination
            page={state?.page}
            limit={state?.limit}
            count={state?.count}
            length={state?.data?.length}
            onPaginationChange={onPaginationChange}
          />
        </ListFooter>
      )}
    </ListingWrapper>
  );
};

export default connect(
  ({ ...reducers }) => ({
    ...reducers,
  }),
  {},
)(React.memo(UpcomingDiamond));
